<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body *ngIf="loading | async">
    <p-progressSpinner></p-progressSpinner>
  </ng-container>
  <ng-container widget-body *ngIf="navigator.current; else noData">
    <div class="full-manager-detail-container">
      <div *ngIf="imageUrl()" class="manager-detail-picture">
        <div class="image" [style.background-image]="imageUrl() | secureImage:true:Fallback.User"></div>
      </div>
      <div class="manager-detail-container">
        <div class="manager-navigator">
          <div class="manager-navigator-button" *ngIf="hasMultiple()">
            <button class="previous" (click)="prev()"><i aria-hidden="true" class="fa fa-angle-left fa-2x"></i></button>
          </div>
          <div class="manager-navigator-center-panel">
            <h1>{{navigator.current.ManagerName}}</h1>
            <h2>{{navigator.current.ManagementType}}</h2>
          </div>
          <div class="manager-navigator-button" *ngIf="hasMultiple()">
            <button class="next" (click)="next()" type="button"><i aria-hidden="true" class="fa fa-angle-right fa-2x"></i></button>
          </div>
        </div>
        <div class="manager-detail">
          <mojo-detail-items-body [data]="getDetailItems()"></mojo-detail-items-body>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template widget-body #noData>
    <div class="manager-details-container">
      <h3>No manager information</h3>
    </div>
  </ng-template>
</mojo-widget>
